module.exports = __webpack_public_path__ + "school/img/readCourseDetailBg.75d54210.jpg";